module.exports = __webpack_public_path__ + "static/media/brush-mode-outside.755e2c13.png";